import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation } from '@tanstack/react-query';

interface UseReportsSubmit {
  onSuccess?: () => void;
  onError?: (error: ErrorResponse) => void;
}

export const useReportSubmit = ({ onSuccess, onError }: UseReportsSubmit) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['reportSubmit'],
    mutationFn: async ({
      filters,
      report_type,
      pdf_visible_headers
    }: {
      filters: { [key: string]: any; },
      report_type: string;
      pdf_visible_headers?: { [key: string]: string[] }
    }) => {
      if (filters?.q) {
        Object.keys(filters?.q).forEach((filterName) => {
          if (filterName.endsWith('_is'))
            filters.q[filterName] = !!filters.q[filterName];
        });
      }

      const payload = {
        ...filters,
        q: {
          ...filters?.q,
          city_id_eq: filters?.q?.city_id_eq ? filters?.q?.city_id_eq?.value : undefined,
          product_id_eq: filters?.q?.product_id_eq ? filters?.q?.product_id_eq?.value : undefined,
          client_branch_id_eq: filters?.q?.client_branch_id_eq ? filters?.q?.client_branch_id_eq?.value : undefined,
          client_equipment_id_eq: filters?.q?.client_equipment_id_eq ? filters?.q?.client_equipment_id_eq?.value : undefined,
          days_without_usage_gteq: filters?.q?.days_without_usage_gteq ? filters?.q?.days_without_usage_gteq : undefined,
          equipment_category_id_eq: filters?.q?.equipment_category_id_eq ? filters.q.equipment_category_id_eq?.value : undefined,
          equipment_status_eq: filters?.q?.equipment_status_eq ? filters.q.equipment_status_eq?.value : undefined,
          property_kind_eq: filters?.q?.property_kind_eq ? filters.q.property_kind_eq?.value : undefined,
          usage_kind_eq: filters?.q?.usage_kind_eq ? filters.q.usage_kind_eq?.value : undefined,
        },
        report_type,
        pdf_visible_headers: pdf_visible_headers || undefined
      };

      await privateAxios.post(`/reports/entries/submit`, payload);
    },
    onSuccess,
    onError,
  });
};
